import React, { useEffect, useState } from "react";
import { sendGetReq } from "../DAL/http";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [contactforms, setContactForms] = useState(null);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: {
      name: { value: '', matchMode: 'contains' },
      // 'country.name': { value: '', matchMode: 'contains' },
      email: { value: '', matchMode: 'contains' },
      // 'representative.name': { value: '', matchMode: 'contains' }
    }
  });

  let networkTimeout = null;

  useEffect(() => {
    loadLazyData();
  }, [lazyState]);

  const loadLazyData = () => {
    setLoading(true);

    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      sendGetReq("contact/" + [lazyState.page] + "/" + [lazyState.rows])
        .then((data) => {
          debugger
          setTotalRecords(data.count);
          setContactForms(data.list);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error getting all Users:", error);
        });



      // CustomerService.getCustomers({ lazyEvent: JSON.stringify(lazyState) }).then((data) => {

      // });
    }, Math.random() * 1000 + 250);
  };

  const onPage = (event) => {
    debugger
    event.page = (event.first)
    setlazyState(event);
  };

  const onSort = (event) => {
    setlazyState(event);
  };

  const onFilter = (event) => {
    event['first'] = 0;
    setlazyState(event);
  };

  const onSelectionChange = (event) => {
    const value = event.value;

    setSelectedCustomers(value);
    // setSelectAll(value.length === totalRecords);
  };

  return (
    <>
      <h2 style={{fontSize:"30px", color:"#0F172A",marginBottom:"30px"}}>Contact form</h2>
      <div class="card mb-4">
        <div class="card-body">

          <DataTable value={contactforms} lazy filterDisplay="row" key="{id}" paginator
            first={lazyState.first} rows={10} totalRecords={totalRecords} onPage={onPage} rowsPerPageOptions={[10, 25, 50, 100]}
            onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
            onFilter={onFilter} filters={lazyState.filters} loading={loading} tableStyle={{ minWidth: '45rem' }}>

            <Column field="name" header="Name" style={{width:"350px"}}/>
            <Column field="email" header="Email" style={{width:"350px"}}/>
            <Column field="phoneNumber" header="PhoneNumber" style={{width:"300px"}}/>

            <Column field="message" header="Message" style={{width:"600px"}} />
            {/* <Column field="Message" sortable filter header="Company" filterPlaceholder="Search" /> */}
          </DataTable>
        </div>
      </div>

    </>
  );
};

export default ContactForm;
